import { createFileRoute } from '@tanstack/react-router';
import { getAuditLogsTitleContextSlice } from '@utils/breadcrumbsUtils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/aliases/audit/$id')({
  beforeLoad: () => getAuditLogsTitleContextSlice(),
});
